// extracted by mini-css-extract-plugin
export default {"header":"styles_header__LD5ja","button":"styles_button__x85lT","title":"styles_title__N4cY2","stepName":"styles_stepName__u+X0i","titleWrap":"styles_titleWrap__o6RL-"};